export const HOME = "/"
export const SUBJECTS = "/subjects"
export const SUBJECT_DETAILS = "/subjects/:subjectID"

export const ACTIONS = "/actions"
export const HEALTH_EXPERIENCES = "/actions/health_experiences"
export const SEMINARS = "/actions/seminars"
export const TV_INTERVIEW = "/actions/tv_interview"

export const VIDEOS = "/videos"
export const TEAM = "/team"

export const ADMIN = "/adminpanel"
export const ADMIN_SUGGESTIONS = "/adminpanel/suggestion_types"
export const ADMIN_SUGGESTION = "/adminpanel/suggestion_types/:suggestionTypeID"
export const ADMIN_SUBJECTS = "/adminpanel/subjects"
export const ADMIN_SUBJECT_EDIT = "/adminpanel/subjects/:subjectID"
export const ADMIN_SUBJECT_EDIT_SUGGESTIONS = "/adminpanel/subjects/:subjectID/suggestions"
export const ADMIN_SEMINARS = "/adminpanel/seminars"
export const ADMIN_SEMINARS_EDIT = "/adminpanel/seminars/:seminarID"
export const ADMIN_HEALTH_EXPERIENCES = "/adminpanel/health_experiences"
export const ADMIN_HEALTH_EXPERIENCES_EDIT = "/adminpanel/health_experiences/:healthExperienceID"